// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file audit_logs.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { UserRef, UserRefJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file audit_logs.proto.
 */
export const file_audit_logs: GenFile = /*@__PURE__*/
  fileDesc("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", [file_general, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message raccoonai.AuditLog
 */
export type AuditLog = Message<"raccoonai.AuditLog"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required raccoonai.AuditLogCategory category = 3;
   */
  category: AuditLogCategory;

  /**
   * @generated from field: required raccoonai.AuditLogType log_type = 4 [json_name = "log_type"];
   */
  logType: AuditLogType;

  /**
   * @generated from field: required uint64 user_id = 5 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: required string user_role = 6 [json_name = "user_role"];
   */
  userRole: string;

  /**
   * @generated from field: required string message = 7;
   */
  message: string;

  /**
   * @generated from field: optional google.protobuf.Struct fields = 8;
   */
  fields?: JsonObject;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 9 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * Who acted. Unset for system events (user_id 0) and for users deleted since.
   *
   * @generated from field: optional raccoonai.UserRef user = 10;
   */
  user?: UserRef;
};

/**
 * @generated from message raccoonai.AuditLog
 */
export type AuditLogJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required raccoonai.AuditLogCategory category = 3;
   */
  category?: AuditLogCategoryJson;

  /**
   * @generated from field: required raccoonai.AuditLogType log_type = 4 [json_name = "log_type"];
   */
  log_type?: AuditLogTypeJson;

  /**
   * @generated from field: required uint64 user_id = 5 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: required string user_role = 6 [json_name = "user_role"];
   */
  user_role?: string;

  /**
   * @generated from field: required string message = 7;
   */
  message?: string;

  /**
   * @generated from field: optional google.protobuf.Struct fields = 8;
   */
  fields?: StructJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 9 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * Who acted. Unset for system events (user_id 0) and for users deleted since.
   *
   * @generated from field: optional raccoonai.UserRef user = 10;
   */
  user?: UserRefJson;
};

/**
 * Describes the message raccoonai.AuditLog.
 * Use `create(AuditLogSchema)` to create a new message.
 */
export const AuditLogSchema: GenMessage<AuditLog, {jsonType: AuditLogJson}> = /*@__PURE__*/
  messageDesc(file_audit_logs, 0);

/**
 * @generated from message raccoonai.AuditLogCreate
 */
export type AuditLogCreate = Message<"raccoonai.AuditLogCreate"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required raccoonai.AuditLogCategory category = 2;
   */
  category: AuditLogCategory;

  /**
   * @generated from field: required raccoonai.AuditLogType log_type = 3 [json_name = "log_type"];
   */
  logType: AuditLogType;

  /**
   * @generated from field: required uint64 user_id = 4 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: required string user_role = 5 [json_name = "user_role"];
   */
  userRole: string;

  /**
   * @generated from field: required string message = 6;
   */
  message: string;

  /**
   * @generated from field: optional google.protobuf.Struct fields = 7;
   */
  fields?: JsonObject;
};

/**
 * @generated from message raccoonai.AuditLogCreate
 */
export type AuditLogCreateJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required raccoonai.AuditLogCategory category = 2;
   */
  category?: AuditLogCategoryJson;

  /**
   * @generated from field: required raccoonai.AuditLogType log_type = 3 [json_name = "log_type"];
   */
  log_type?: AuditLogTypeJson;

  /**
   * @generated from field: required uint64 user_id = 4 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: required string user_role = 5 [json_name = "user_role"];
   */
  user_role?: string;

  /**
   * @generated from field: required string message = 6;
   */
  message?: string;

  /**
   * @generated from field: optional google.protobuf.Struct fields = 7;
   */
  fields?: StructJson;
};

/**
 * Describes the message raccoonai.AuditLogCreate.
 * Use `create(AuditLogCreateSchema)` to create a new message.
 */
export const AuditLogCreateSchema: GenMessage<AuditLogCreate, {jsonType: AuditLogCreateJson}> = /*@__PURE__*/
  messageDesc(file_audit_logs, 1);

/**
 * @generated from message raccoonai.AuditLogUpdate
 */
export type AuditLogUpdate = Message<"raccoonai.AuditLogUpdate"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: optional raccoonai.AuditLogCategory category = 2;
   */
  category: AuditLogCategory;

  /**
   * @generated from field: optional raccoonai.AuditLogType log_type = 3 [json_name = "log_type"];
   */
  logType: AuditLogType;

  /**
   * @generated from field: optional uint64 user_id = 4 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: optional string user_role = 5 [json_name = "user_role"];
   */
  userRole: string;

  /**
   * @generated from field: optional string message = 6;
   */
  message: string;

  /**
   * @generated from field: optional google.protobuf.Struct fields = 7;
   */
  fields?: JsonObject;
};

/**
 * @generated from message raccoonai.AuditLogUpdate
 */
export type AuditLogUpdateJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: optional raccoonai.AuditLogCategory category = 2;
   */
  category?: AuditLogCategoryJson;

  /**
   * @generated from field: optional raccoonai.AuditLogType log_type = 3 [json_name = "log_type"];
   */
  log_type?: AuditLogTypeJson;

  /**
   * @generated from field: optional uint64 user_id = 4 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: optional string user_role = 5 [json_name = "user_role"];
   */
  user_role?: string;

  /**
   * @generated from field: optional string message = 6;
   */
  message?: string;

  /**
   * @generated from field: optional google.protobuf.Struct fields = 7;
   */
  fields?: StructJson;
};

/**
 * Describes the message raccoonai.AuditLogUpdate.
 * Use `create(AuditLogUpdateSchema)` to create a new message.
 */
export const AuditLogUpdateSchema: GenMessage<AuditLogUpdate, {jsonType: AuditLogUpdateJson}> = /*@__PURE__*/
  messageDesc(file_audit_logs, 2);

/**
 * @generated from enum raccoonai.AuditLogCategory
 */
export enum AuditLogCategory {
  /**
   * @generated from enum value: AUDIT_LOG_CATEGORY_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: AUDIT_LOG_CATEGORY_AI_DECISION = 1;
   */
  AI_DECISION = 1,

  /**
   * @generated from enum value: AUDIT_LOG_CATEGORY_TRUCK = 2;
   */
  TRUCK = 2,

  /**
   * @generated from enum value: AUDIT_LOG_CATEGORY_OFFICE = 3;
   */
  OFFICE = 3,

  /**
   * @generated from enum value: AUDIT_LOG_CATEGORY_GOV = 4;
   */
  GOV = 4,
}

/**
 * @generated from enum raccoonai.AuditLogCategory
 */
export type AuditLogCategoryJson = "AUDIT_LOG_CATEGORY_UNDEFINED" | "AUDIT_LOG_CATEGORY_AI_DECISION" | "AUDIT_LOG_CATEGORY_TRUCK" | "AUDIT_LOG_CATEGORY_OFFICE" | "AUDIT_LOG_CATEGORY_GOV";

/**
 * Describes the enum raccoonai.AuditLogCategory.
 */
export const AuditLogCategorySchema: GenEnum<AuditLogCategory, AuditLogCategoryJson> = /*@__PURE__*/
  enumDesc(file_audit_logs, 0);

/**
 * @generated from enum raccoonai.AuditLogType
 */
export enum AuditLogType {
  /**
   * @generated from enum value: AUDIT_LOG_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * 100 - 150 Truck related events
   *
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_AVAILABLE = 101;
   */
  TRUCK_AVAILABLE = 101,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_ARRIVED_AT_LOCATION = 102;
   */
  TRUCK_ARRIVED_AT_LOCATION = 102,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_ARRIVED_AT_DEPOT = 103;
   */
  TRUCK_ARRIVED_AT_DEPOT = 103,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_LEFT_LOCATION = 104;
   */
  TRUCK_LEFT_LOCATION = 104,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_ISSUE_REPORTED = 105;
   */
  TRUCK_ISSUE_REPORTED = 105,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_SENT_TO_REPAIR = 106;
   */
  TRUCK_SENT_TO_REPAIR = 106,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_RETURNED_FROM_REPAIR = 107;
   */
  TRUCK_RETURNED_FROM_REPAIR = 107,

  /**
   * 150 - 200 Truck shift related events
   *
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_SHIFT_CREATED = 151;
   */
  TRUCK_SHIFT_CREATED = 151,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_SHIFT_COMPLETED = 152;
   */
  TRUCK_SHIFT_COMPLETED = 152,

  /**
   * Driver reported a problem while on shift ("проблема на линии").
   * Unrelated to the TruckIncident (repairs) entity. The specific
   * DriverIncidentType is carried in fields.incident_type.
   *
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_SHIFT_INCIDENT_REPORTED = 153;
   */
  TRUCK_SHIFT_INCIDENT_REPORTED = 153,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_SHIFT_CANCELLED = 154;
   */
  TRUCK_SHIFT_CANCELLED = 154,

  /**
   * 200 - 250 Job related events
   *
   * @generated from enum value: AUDIT_LOG_TYPE_JOB_CREATED = 201;
   */
  JOB_CREATED = 201,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_JOB_STARTED = 202;
   */
  JOB_STARTED = 202,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_JOB_COMPLETED = 203;
   */
  JOB_COMPLETED = 203,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_JOB_CANCELLED = 204;
   */
  JOB_CANCELLED = 204,

  /**
   * Driver reported a problem on the current job ("проблема на задаче").
   * The specific DriverIncidentType is carried in fields.incident_type.
   *
   * @generated from enum value: AUDIT_LOG_TYPE_JOB_INCIDENT_REPORTED = 205;
   */
  JOB_INCIDENT_REPORTED = 205,

  /**
   * Any save of a job by a user; the newest one per job is its "last updated by".
   *
   * @generated from enum value: AUDIT_LOG_TYPE_JOB_UPDATED = 206;
   */
  JOB_UPDATED = 206,

  /**
   * Job moved CREATED -> ASSIGNED with a driver on shift.
   *
   * @generated from enum value: AUDIT_LOG_TYPE_JOB_ASSIGNED = 207;
   */
  JOB_ASSIGNED = 207,

  /**
   * 250 - 300 Route related events
   *
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_CREATED = 251;
   */
  ROUTE_CREATED = 251,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_STARTED = 252;
   */
  ROUTE_STARTED = 252,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_RETURNING = 253;
   */
  ROUTE_RETURNING = 253,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_MANUALLY_COMPLETED = 254;
   */
  ROUTE_MANUALLY_COMPLETED = 254,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_CANCELLED = 255;
   */
  ROUTE_CANCELLED = 255,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_COMPLETED = 256;
   */
  ROUTE_COMPLETED = 256,

  /**
   * Route moved NOT_APPROVED -> CREATED.
   *
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_APPROVED = 257;
   */
  ROUTE_APPROVED = 257,

  /**
   * Jobs added to or removed from a route; ids in fields.added_job_ids / removed_job_ids.
   *
   * @generated from enum value: AUDIT_LOG_TYPE_ROUTE_JOBS_CHANGED = 258;
   */
  ROUTE_JOBS_CHANGED = 258,

  /**
   * addition and update events
   *
   * @generated from enum value: AUDIT_LOG_TYPE_CLIENT_ADDED = 301;
   */
  CLIENT_ADDED = 301,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_CLIENT_UPDATED = 302;
   */
  CLIENT_UPDATED = 302,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_LOCATION_ADDED = 311;
   */
  LOCATION_ADDED = 311,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_LOCATION_UPDATED = 312;
   */
  LOCATION_UPDATED = 312,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_DRIVER_ADDED = 321;
   */
  DRIVER_ADDED = 321,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_DRIVER_UPDATED = 322;
   */
  DRIVER_UPDATED = 322,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_ADDED = 331;
   */
  TRUCK_ADDED = 331,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_TRUCK_UPDATED = 332;
   */
  TRUCK_UPDATED = 332,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_CONTACT_ADDED = 341;
   */
  CONTACT_ADDED = 341,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_CONTACT_UPDATED = 342;
   */
  CONTACT_UPDATED = 342,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_SUSPICIOUS_LOCATION_ARCHIVED = 351;
   */
  SUSPICIOUS_LOCATION_ARCHIVED = 351,

  /**
   * @generated from enum value: AUDIT_LOG_TYPE_SUSPICIOUS_LOCATION_UNARCHIVED = 352;
   */
  SUSPICIOUS_LOCATION_UNARCHIVED = 352,

  /**
   * 400 - 500 AI related events
   *
   * @generated from enum value: AUDIT_LOG_TYPE_AI_ROUTE_ASSIGNED = 401;
   */
  AI_ROUTE_ASSIGNED = 401,
}

/**
 * @generated from enum raccoonai.AuditLogType
 */
export type AuditLogTypeJson = "AUDIT_LOG_TYPE_UNDEFINED" | "AUDIT_LOG_TYPE_TRUCK_AVAILABLE" | "AUDIT_LOG_TYPE_TRUCK_ARRIVED_AT_LOCATION" | "AUDIT_LOG_TYPE_TRUCK_ARRIVED_AT_DEPOT" | "AUDIT_LOG_TYPE_TRUCK_LEFT_LOCATION" | "AUDIT_LOG_TYPE_TRUCK_ISSUE_REPORTED" | "AUDIT_LOG_TYPE_TRUCK_SENT_TO_REPAIR" | "AUDIT_LOG_TYPE_TRUCK_RETURNED_FROM_REPAIR" | "AUDIT_LOG_TYPE_TRUCK_SHIFT_CREATED" | "AUDIT_LOG_TYPE_TRUCK_SHIFT_COMPLETED" | "AUDIT_LOG_TYPE_TRUCK_SHIFT_INCIDENT_REPORTED" | "AUDIT_LOG_TYPE_TRUCK_SHIFT_CANCELLED" | "AUDIT_LOG_TYPE_JOB_CREATED" | "AUDIT_LOG_TYPE_JOB_STARTED" | "AUDIT_LOG_TYPE_JOB_COMPLETED" | "AUDIT_LOG_TYPE_JOB_CANCELLED" | "AUDIT_LOG_TYPE_JOB_INCIDENT_REPORTED" | "AUDIT_LOG_TYPE_JOB_UPDATED" | "AUDIT_LOG_TYPE_JOB_ASSIGNED" | "AUDIT_LOG_TYPE_ROUTE_CREATED" | "AUDIT_LOG_TYPE_ROUTE_STARTED" | "AUDIT_LOG_TYPE_ROUTE_RETURNING" | "AUDIT_LOG_TYPE_ROUTE_MANUALLY_COMPLETED" | "AUDIT_LOG_TYPE_ROUTE_CANCELLED" | "AUDIT_LOG_TYPE_ROUTE_COMPLETED" | "AUDIT_LOG_TYPE_ROUTE_APPROVED" | "AUDIT_LOG_TYPE_ROUTE_JOBS_CHANGED" | "AUDIT_LOG_TYPE_CLIENT_ADDED" | "AUDIT_LOG_TYPE_CLIENT_UPDATED" | "AUDIT_LOG_TYPE_LOCATION_ADDED" | "AUDIT_LOG_TYPE_LOCATION_UPDATED" | "AUDIT_LOG_TYPE_DRIVER_ADDED" | "AUDIT_LOG_TYPE_DRIVER_UPDATED" | "AUDIT_LOG_TYPE_TRUCK_ADDED" | "AUDIT_LOG_TYPE_TRUCK_UPDATED" | "AUDIT_LOG_TYPE_CONTACT_ADDED" | "AUDIT_LOG_TYPE_CONTACT_UPDATED" | "AUDIT_LOG_TYPE_SUSPICIOUS_LOCATION_ARCHIVED" | "AUDIT_LOG_TYPE_SUSPICIOUS_LOCATION_UNARCHIVED" | "AUDIT_LOG_TYPE_AI_ROUTE_ASSIGNED";

/**
 * Describes the enum raccoonai.AuditLogType.
 */
export const AuditLogTypeSchema: GenEnum<AuditLogType, AuditLogTypeJson> = /*@__PURE__*/
  enumDesc(file_audit_logs, 1);

